import React, { useState, useEffect } from "react";
import "../styles/Uiux.css";
import "../styles/Carousel.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import ContactPage from "./ContactPage";
import { motion } from "framer-motion";
const Uiux = () => {
  const [visibleRows, setVisibleRows] = useState({});
  const [activeIndex, setActiveIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const navigate = useNavigate();
  const handleClicked = () => {
    navigate("/contact");
  };
  const fadeInUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 }
  };
  // const services = [
  //   {
  //     title: "Android UI/UX",
  //     description:
  //       "Our team creates an efficient user-friendly design for android applications that is appropriate in all user devices."
  //   },
  //   {
  //     title: "Ecommerce UI/UX",
  //     description:
  //       "We have an expert team to create a user-friendly design with easy sequence of movements or actions for shopping sites."
  //   },
  //   {
  //     title: "Web UI/UX Design",
  //     description:
  //       "Our team creates innovative and compatibility web page design that looks more effective and appropriate in all user devices."
  //   },
  //   {
  //     title: "Dashboard UI/UX",
  //     description:
  //       "Dashboard UI/UX prioritizes clear data visualization and intuitive navigation. We create a layout for efficient information access, ensuring users quickly evaluate key metrics and insights, fostering informed decision-making."
  //   },
  //   {
  //     title: "Product Design",
  //     description:
  //       "We create effective designs for products website like ecommerce and online shopping sites that our expert team will provide leading technologies skills that enhance your site visibility."
  //   },
  //   {
  //     title: "Web/App Redesign",
  //     description:
  //       "Web and App redesign a digital experience. It focuses on improving usability, aesthetics, and functionality, addressing user feedback and evolving trends, to enhance engagement and achieve business goals."
  //   }
  // ];
  const features1 = [
    {
      img: "/images/bg1.webp",
      bgImg: "/images/bg1.webp",
      title: "User research",
      description:
        "Research is the key to create a design. Whether it's user interface or user experience, what users think of your product is important. Detailed research lays a great foundation for creating a neat design."
    },
    {
      img: "/images/bg2.webp",
      bgImg: "/images/bg2.webp",
      title: "Crafting strategy",
      description:
        "It involves setting clear goals, analyzing data, understanding user needs, and iterating solutions. A well-defined strategy ensures efficiency, adaptability, and long-term success in any project or business endeavor."
    },
    {
      img: "/images/bg3.webp",
      bgImg: "/images/bg3.webp",
      title: "Designing",
      description:
        "It is a creative process that blends aesthetics, functionality and user needs. It requires research, planning, and iteration to craft intuitive, visually appealing and effective solutions that enhance user experiences and solve problems."
    },
    {
      img: "/images/bg4.webp",
      bgImg: "/images/bg4.webp",
      title: "Development",
      description:
        "It is the process of transforming ideas into functional solutions. It involves planning, coding, testing, and refining to create efficient, scalable, and user-friendly products that meet evolving needs and industry standards."
    }
  ];
  // const slides = [
  //   {
  //     image: img1,
  //     steps: "Step 1",
  //     title: "User Research",
  //     description:
  //       "User acquisition and retention are key resonance on what users think of the product. a detailed research and best understanding of user behavior help us lay basic foundation for a great and interface."
  //   },
  //   {
  //     image: img2,
  //     steps: "Step 2",
  //     title: "Work and user flow",
  //     description:
  //       "A sequence of movements or actions of users is staged where the goal is to optimize users ability to accomplish a task with the least amount of effort. At this stage, Multiple such scenarios are Challenged and best possible solutions are devised."
  //   },
  //   {
  //     image: img3,
  //     steps: "Step 3",
  //     title: "Wireframing & Skinning",
  //     description:
  //       "Based on the finalized user flow and scenarios, the architecture of screens is created. At this step, the ideas are presented to the client and an intial understanding is established between UX, UI and development teams. The UI Team develops the final GUI for the finalized Screens."
  //   },
  //   {
  //     image: img4,
  //     steps: "Step 4",
  //     title: "Design & Prototyping",
  //     description:
  //       "Before the development and after the GUI, the designs are prototyped to look out for frictions, practical user tests. Appropriate feedback and results of users testing are implemented in the design."
  //   },
  //   {
  //     image: img5,
  //     steps: "Step 5",
  //     title: "Development",
  //     description:
  //       "The Finalized design are developed in HTML, Compatible with various devices and resolutions."
  //   }
  // ];

  // const content = [
  //   {
  //     step: "Step 1",
  //     title: "User Research",
  //     description:
  //       "A detailed research about user behaviour that helps us to create a layout with user interface."
  //   },
  //   {
  //     step: "Step 2",
  //     title: "Work and user flow",
  //     description:
  //       "A user-friendly sequence of movements or actions for a user is optimized at this stage."
  //   },
  //   {
  //     step: "Step 3",
  //     title: "Wireframing & Skinning",
  //     description:
  //       "At this step the UI/UX team integrate the entire ideas and design by using GUI tools. "
  //   },
  //   {
  //     step: "Step 4",
  //     title: "Design & Prototyping",
  //     description:
  //       "After GUI stage designs are prototyped look for user tests. After getting feedback on the test process re-implement the design."
  //   },
  //   {
  //     step: "Step 5",
  //     title: "Development",
  //     description:
  //       "The finalized designs are developed in HTML, Compatible with various devices and resolutions."
  //   }
  // ];

  // const [currentIndex, setCurrentIndex] = useState(0);
  // const nextSlide = () => {
  //   setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  // };

  // const prevSlide = () => {
  //   setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  // };

  // const goToSlide = (index) => {
  //   setCurrentIndex(index);
  // };
  const handleToggle = (id) => {
    setVisibleRows((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  const data = [
    {
      id: 1,
      title: "How do you prioritize user needs when designing a website?",
      content:
        "We conduct thorough user research and usability testing, to understand their goals and points."
    },
    {
      id: 2,
      title: "What's your process for designing effective website navigation?",
      content:
        "We start by analyzing the site's information architecture, creating clear and logical navigation menus. We use intuitive labels, consistent placement and visual cues to guide users. We conduct a usability testing to ensure users can easily find what they're looking."
    },
    {
      id: 3,
      title: "How do you test your website designs?",
      content:
        "We use a combination of methods, including usability testing with real users, A/B testing to compare different design variations, and heuristic evaluation to identify potential usability issues. We analyze user data and feedback to iterate and improve our designs."
    },
    {
      id: 4,
      title: "Difference between UI/UX Design?",
      content:
        "User interface (UI) refers to the interactivity, look and feel of a product screen or web page, While User experience (UX) refers to a user's overall experience with the product or website."
    }
  ];
  // const features = [
  //   {
  //     img: "/images/image 26.webp",
  //     bgImg: "/images/bg1.webp",
  //     title: "User-Centric Approach",
  //     description:
  //       "A user-centric approach prioritizes understanding and meeting user needs. It involves research, testing, and iteration, ensuring products and services are intuitive, accessible, and deliver a positive, fulfilling experience."
  //   },
  //   {
  //     img: "/images/image 27.webp",
  //     bgImg: "/images/bg2.webp",
  //     title: "Emotional Design Impact",
  //     description:
  //       "User connection by stimulating emotions. It creates memorable experiences through visual appeal, intuitive interactions, and resonant narratives, enhancing engagement and brand loyalty beyond mere functionality."
  //   },
  //   {
  //     img: "/images/image 28.webp",
  //     bgImg: "/images/bg3.webp",
  //     title: "Accessibility Integration",
  //     description:
  //       "Accessibility integration ensures digital products are usable by everyone. It involves user-friendly technologies and inclusive design practices throughout the development process."
  //   },
  //   {
  //     img: "/images/image 29.webp",
  //     bgImg: "/images/bg4.webp",
  //     title: "Multi-Platform Consistency",
  //     description:
  //       "It delivers a unified user experience across devices. It ensures design elements, functionality, and brand messaging remain coherent, fostering familiarity and seamless transitions, regardless of the user's chosen platform."
  //   },
  //   {
  //     img: "/images/image 30.webp",
  //     bgImg: "/images/bg5.webp",
  //     title: "Data-Driven Iteration",
  //     description:
  //       "Users analyze the design patterns and performance metrics, make adjustments, improvements, and optimize user experience."
  //   },
  //   {
  //     img: "/images/image 31.webp",
  //     bgImg: "/images/bg6.webp",
  //     title: "Storytelling Through Design",
  //     description:
  //       "We bring your brand story to life. Through captivating visuals and interactive design elements, we craft narratives that resonate and leave a lasting impression."
  //   }
  // ];
  return (
    <>
      <section className="uiuxsection">
        <div className="uiuxsection1">
          <motion.h2
            className="uiuxsection2"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            UI UX design company in Salem to make a better digital experience{" "}
          </motion.h2>
          <motion.p
            className="fsp uiuxsection3"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8, ease: "easeOut" }}
          >
            At MPeoples, we collaborate with top UI/UX designers to craft
            digital experiences that elevate your business to new heights.
          </motion.p>
          <motion.button
            className="uiuxbutton"
            onClick={handleClicked}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 1, duration: 0.5 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Let's talk &#8594;
          </motion.button>
        </div>
      </section>
      <section className="uiiuxx">
        <motion.h2
          className="fsh2 m1"
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
          transition={{ duration: 0.5 }}
        >
          SERVICES
        </motion.h2>
        <motion.h2
          className="fsh3 m0 mb2"
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
          transition={{ duration: 0.7 }}
        >
          UX/UI Design Services we Offer
        </motion.h2>
        <div className="serviceoffer">
          <div className="serviceoffer1">
            {[
              { img: "image 76.webp", title: "Android App" },
              {
                img: "image 77.webp",
                title: "IOS App",
                style: { marginRight: "300px" }
              },
              { img: "image 78.webp", title: "Hybrid App" }
            ].map((item, index) => (
              <motion.div
                className="serviceoffer3"
                key={index}
                style={item.style}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="serviceoffer2">
                  <img src={`/images/${item.img}`} alt={item.title} />
                </div>
                <div>
                  <h2 className="serviceoffer4">{item.title}</h2>
                </div>
              </motion.div>
            ))}
          </div>
          <motion.div
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <img src="/images/iPhone.webp" alt="iphone" />
          </motion.div>
          <div className="serviceoffer1">
            {[
              { img: "image 79.webp", title: "Web App" },
              {
                img: "image 80.webp",
                title: "Website Design",
                style: { marginLeft: "300px" }
              },
              { img: "image 81.webp", title: "Usability Testing" }
            ].map((item, index) => (
              <motion.div
                className="serviceoffer3"
                key={index}
                style={item.style}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="serviceoffer2">
                  <img src={`/images/${item.img}`} alt={item.title} />
                </div>
                <div>
                  <h2 className="serviceoffer4">{item.title}</h2>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
      <section className="mainsec2 d-flex flex-column justify-content-center align-items-center m">
        <div className="text-start text-md-center d-flex flex-column align-items-left align-items-md-center justify-content-center mb2">
          <h2 className="fsh2 m0 mb2">Process</h2>
          <p className="fsh3 m0 mb2">How do we process UI/UX designing</p>
        </div>
        <div className="row g-4">
          {features1.map((feature, index) => (
            <div key={index} className="col-md-10 col-lg-6">
              <div
                className="card shadow-sm p-3 h-100 d-flex flex-column justify-content-center align-items-center section2box"
                style={{ border: "2px solid #137eb1" }}
              >
                <div
                  className="d-flex justify-content-between justify-content-md-center align-items-center w-100"
                  onClick={() => isMobile && toggleAccordion(index)}
                  style={{ cursor: isMobile ? "pointer" : "default" }}
                >
                  <div className="d-flex flex-md-column align-items-center justify-content-center gap-3">
                    <div className="section2img">
                      <img
                        src={feature.img}
                        alt={feature.title}
                        className="card-img-top img-fluid"
                      />
                    </div>
                    <h5 className="fsh4">{feature.title}</h5>
                  </div>
                  <div>
                    {isMobile && (
                      <span className="fs-4">
                        {activeIndex === index ? "−" : "+"}
                      </span>
                    )}
                  </div>
                </div>
                <div
                  className={`card-body ${isMobile ? "accordion-content" : ""}`}
                  style={{
                    display: isMobile
                      ? activeIndex === index
                        ? "block"
                        : "none"
                      : "block",
                    transition: "all 0.3s ease"
                  }}
                >
                  {/* <h5 className="fsh4">{feature.title}</h5> */}
                  <p className="fsp">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section
        className="m"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div className="builder">
          <div className="builderimage">
            <img
              src={"/images/guy.webp"}
              alt=""
              style={{
                height: "236px",
                marginBottom: "32px",
                textShadow: "2px 2px 4px #000000"
              }}
            />
          </div>
          <div className="buiderimage1">
            <h2 className="fsh3" style={{ color: "white" }}>
              Better discussions, better decisions
            </h2>
            <p className="fsp" style={{ color: "#FBBC04" }}>
              We are for everyone - Startups, SMBs, Enterprises. Connect with us
              for a conversation.
            </p>
            <button className="button" style={{ textAlign: "right" }}>
              <span className="text2">
                {" "}
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href="/contact"
                >
                  Speak to us &rarr;
                </a>
              </span>
              <div className="circle2"></div>
            </button>
          </div>
        </div>
      </section>
      <ContactPage />
      {/* <section className="m">
        <div className="text-center">
          <h4 className="fsh2 m0 mb2">Difference between UI/UX Design</h4>
          <p className="fsp">
            User interface (UI) refers to the interactivity, look, and feel of a
            product screen or web page.
          </p>
          <p className="fsp">
            User experience (UX) refers to a user's overall experience with the
            product or website.
          </p>
        </div>
      </section> */}
      {/* <section className="mainsec2 d-flex flex-column justify-content-center align-items-center m">
        <div className="text-center d-flex flex-column align-items-center -justify-content-center">
          <h2 className="fsh2 m0 mb2">Connecting Users and Business</h2>
          <p className="fsp m0 mb2 col-10">
            UX designers create layout intuitive and user-friendly digital
            experiences. We research, design, and test interfaces, ensuring
            usability and satisfaction and connecting user needs with business
            goals.
          </p>
        </div>
        <div className="row g-4 mt-2 ">
          {features.map((feature, index) => (
            <div key={index} className="col-md-6 col-lg-4 ">
              <div className="card border-0 shadow-sm p-3 h-100 d-flex flex-column justify-content-center align-items-center section2img section2box">
                <img
                  src={feature.img}
                  alt={feature.title}
                  className="card-img-top img-fluid"
                />
                <div className="card-body">
                  <h5 className="fsh4">{feature.title}</h5>
                  <p className="fsp">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section> */}
      {/* <section className="m">
        <div className="">
          <h2 className="fsh2 m0 mb2">Our UI/UX Design Services</h2>
          <div className="row g-4">
            {[
              {
                title: "Transparent & Collaborative Team",
                description:
                  "We communicate everything across teams and collaborate effectively to complete tasks on time with proper coordination."
              },
              {
                title: "On-time Project Delivery",
                description:
                  "We set specific goals and timelines to ensure projects are delivered efficiently and on schedule."
              },
              {
                title: "Results-Oriented Solutions",
                description:
                  "We focus on strategies that provide the best digital solutions to enhance customer experience and drive business growth."
              },
              {
                title: "UI Testing Approach",
                description:
                  "Our expert design team thoroughly tests the entire layout flow before delivery to ensure a seamless user experience."
              },
              {
                title: "Best Services",
                description:
                  "Our quality UI/UX design team delivers top-notch results and digital solutions tailored to customer needs."
              },
              {
                title: "Customer Experience Design",
                description:
                  "As a UI/UX design agency, we create engaging designs that enhance user experience, making them intuitive, attractive, and easy to use."
              }
            ].map((item, index) => (
              <div className="col-md-4" key={index}>
                <div className="p-4 border rounded shadow-sm bg-white feature-card">
                  <h3 className="fsh4">{item.title}</h3>
                  <p className="fsp">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
      {/* <section className="section3 sec3ui">
        <h2 className="fsh2 m0 mb2">Our UI/UX Design Process</h2>
        <div className="carousel-section">
          <div className="content-container">
            <div className="text-content">
              <div className="feature-content">
                <h3 className="fsh3 m0 mb2">{slides[currentIndex].steps}</h3>
                <h2 className="fsh2 m0 mb2">{slides[currentIndex].title}</h2>
                <p className="fsp">{slides[currentIndex].description}</p>
              </div>
            </div>
            <div className="carousel-wrapper">
              <div className="carousel-container">
                <div className="mobile-frame">
                  <div className="phone-notch"></div>
                  <div className="phone-speaker"></div>
                  <div className="carousel-track">
                    {slides.map((slide, index) => {
                      const position =
                        index === currentIndex
                          ? "active"
                          : index ===
                            (currentIndex - 1 + slides.length) % slides.length
                          ? "left"
                          : index === (currentIndex + 1) % slides.length
                          ? "right"
                          : "hidden";
                      return (
                        <div
                          key={index}
                          className={`carousel-slide ${position}`}
                        >
                          <img
                            src={slide.image}
                            alt={slide.title}
                            className="carousel-image"
                          />
                        </div>
                      );
                    })}
                  </div>
                  <div className="phone-home-indicator"></div>
                </div>
                <button className="nav-btn prev-btn" onClick={prevSlide}>
                  &#10094;
                </button>
                <button className="nav-btn next-btn" onClick={nextSlide}>
                  &#10095;
                </button>
              </div>
              <div className="dots-container">
                {slides.map((_, index) => (
                  <button
                    key={index}
                    className={`dot ${index === currentIndex ? "active" : ""}`}
                    onClick={() => goToSlide(index)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* <section className="m">
        <div className="">
          <div className="text-center mb-5">
            <h2 className="fsh2 m0 mb2 section-heading1">
              Our UI/UX Design Services
            </h2>
          </div>
          <div className="row g-4">
            {services.map((service, index) => (
              <div key={index} className="col-md-6 col-lg-4">
                <div className="service-card1">
                  <div className="service-inner1">
                    <div className="service-front1">
                      <h3 className="fsh3">{service.title}</h3>
                    </div>
                    <div className="service-back1">
                      <p className="fsp">{service.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
    </>
  );
};
export default Uiux;
